export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: "猎奇吃瓜主要收录哪些类型的内容？",
    answer:
      "目前分为六类：未解之谜、灵异杂谈、都市传说、超自然现象、悬疑档案与暗网传闻。我们更偏爱那些有明确时间、地点与来源出处的题材，而不是纯粹的惊悚故事。",
  },
  {
    question: "站内的悬案内容有确凿结论吗？",
    answer:
      "没有。悬案之所以是悬案，正是因为缺少决定性证据。我们的写法是把已知事实、时间线、各方说法和常见推测都摆出来，让读者自己判断，而不是替你下结论。",
  },
  {
    question: "文章里的灵异内容都是真实的吗？",
    answer:
      "灵异杂谈板块以读者投稿与口述记录为主，我们保留讲述者的原话，同时标注可能的技术或心理学解释。它们更适合被当作一种体验记录来阅读，而不是事实认定。",
  },
  {
    question: "多久更新一次？可以投稿吗？",
    answer:
      "常规更新频率大约是每周两到三篇，遇到有完整资料的旧案会做深度长文。欢迎通过投稿邮箱提供线索、照片来源或勘误，被采用的线索会在文中标注致谢。",
  },
  {
    question: "为什么有的文章没有配图或配图是插画？",
    answer:
      "涉及真实案件、私人居所或未经证实的人物时，我们会刻意避免使用可被误解为现场照片的图像，改用抽象插画，避免对当事人和读者造成误导。",
  },
  {
    question: "内容可以转载或引用吗？",
    answer:
      "欢迎在注明来源与原文链接的前提下非商业转载。如需整站转载、影视改编或商业合作，请先来信说明用途，我们会尽快回复。",
  },
  {
    question: "你们会收集我的访问信息吗？",
    answer:
      "订阅表单只收集你主动填写的邮箱，用于发送更新提醒，可随时来信退订。站内不要求注册，也不会索取任何与内容无关的个人信息。",
  },
  {
    question: "阅读这些内容会有什么心理影响吗？",
    answer:
      "部分题材涉及暴力、失踪与超自然体验，可能引起不适。建议不要在深夜独自阅读，也不要因为一时好奇前往传闻地点探访——现实世界的安全永远比猎奇更重要。",
  },
];